import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Pressable,
  ScrollView
} from "react-native";

import { White, WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let brandPos = 1;
let brandFlag = 1;
let isMobile = false;
let scale = 1;
const arrowRight = require("../images/arrowright.png");
const arrowRight2 = require("../images/arrowright2.png");
const jo1 = require("../images/home/jo1.png");
const jo2 = require("../images/home/jo2.png");
const jo3 = require("../images/home/jo3.png");
const jo4 = require("../images/home/jo4.png");
const jo5 = require("../images/home/jo5.png");
// const videothumb2 = require("../images/home/videothumb2.png");
class Pharmacovigilance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      isVideoPlaying: false,
      brands: [],
      joImgPos: 0,
      hideScrollTopButton: true
    };
  }
  Pressables = {};

  async componentDidMount() {
  }


  renderPressableButton = (componentRef, text, onPress) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={isHovered ? Styles.ButtonStyleHovered : Styles.ButtonStyle}>
          <Text style={isHovered ? Styles.ButtonTextStyleHovered : Styles.ButtonTextStyle}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderPressableLink = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle, {
            fontSize: 15
          }]}>{text}</Text>
          <Image source={isHovered ? arrowRight2 : arrowRight} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderMobile() {
    scale = width / 420;
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          <View style={{ width, paddingHorizontal: 20, gap: 50 }}>
            {Commons.loadFonts(this)}
            {Styles.renderVSeparator(0)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {Commons.renderFooter({}, this)}
          </View>
        </ScrollView >

      </View >
    );
  }

  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    width = Commons.getWidth();
    styles = this.styles();
    marginTop = 300;
    styles = this.styles();
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={"Pharmacovigilance"}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          {this.renderPart1()}
          {this.renderPart2()}
          {/* {this.renderPart3()} */}
          {/* {this.renderPart4()} */}
          {/* {this.renderPart5()} */}
          {/* {this.renderPart6()} */}
          {Commons.renderFooter({}, this)}
        </ScrollView >

      </View >
    );
  }

  renderPart1 = () => {
    return (<View style={{
      width,
      flexDirection: 'column',
      display: 'flex',
      gap: 30,
      alignItems: 'flex-start',
      marginTop: 200,
      paddingLeft: 164,
    }}>
      <Text style={[Styles.TextStyle3]}>Pharmacovigilance</Text>
      <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
        At Jordan Drugstore Co., we take your health and safety seriously. If you have any concerns about the safety or
        {'\n'}efficacy of the pharmaceutical products we distribute or if you wish to report an adverse event, we encourage
        {'\n'}you to reach out to our Pharmacovigilance team. Your feedback is invaluable and helps us maintain the highest
        {'\n'}standards of quality and safety.
      </Text>
    </View>)
  }

  renderPart1Mobile = () => {
    return (<View style={{
      flexDirection: 'column',
      gap: 30,
    }}>
      <Text style={[Styles.TextStyle3]}>Pharmacovigilance</Text>
      <Text style={[Styles.TextStyle2, { color: Styles.appColor3 }]}>
        At Jordan Drugstore Co., we take your health and safety
        seriously. If you have any concerns about the safety or
        efficacy of the pharmaceutical products we distribute or if
        you wish to report an adverse event, we encourage you to
        reach out to our Pharmacovigilance team. Your feedback
        is invaluable and helps us maintain the highest standards
        of quality and safety.
      </Text>
    </View>)
  }

  renderPart2 = () => {
    return (<View style={{
      width,
      marginTop: 150,
      paddingLeft: 164,
      flexDirection: 'row',
    }}>

      <View style={{ height: 329, width: 2, borderLeftWidth: 2, borderLeftColor: Styles.appColor1 }} />
      <View style={{ flexDirection: 'column', gap: 40, justifyContent: 'flex-start', marginLeft: 30, marginTop: 40 }}>
        <Text style={[Styles.TextStyle2, { fontSize: 20 }]}>Contact Information</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3, fontSize: 16 }]}>
          {' \u2022 Email: pv@jdsco.net'}
          {'\n'}{' \u2022 Phone1: +962 6 655 6125 Ext. 2'}
          {'\n'}{' \u2022 Phone2: +962 6 563 4488 Ext. 2 '}
          {'\n'}{' \u2022 Address: 48 Issam Al Ajlouni Street, Shmeisani,\n   Amman, Jordan'}
        </Text>
      </View>

      <View style={{ height: 329, width: 2, borderLeftWidth: 2, borderLeftColor: Styles.appColor1, marginLeft: 164 }} />
      <View style={{ flexDirection: 'column', gap: 40, justifyContent: 'flex-start', marginLeft: 30, marginTop: 40 }}>
        <Text style={[Styles.TextStyle2, { fontSize: 20 }]}>Reporting Guidelines</Text>
        <Text style={[Styles.TextStyle2, { color: Styles.appColor3, fontSize: 16 }]}>
          When reporting an adverse event or safety concern, please provide the
          {'\n'}following information, if possible:
          {'\n \u2022 Product Name'}
          {'\n'}{' \u2022 Batch/Lot Number'}
          {'\n'}{' \u2022 Date of Event'}
          {'\n'}{' \u2022 Patient Information (if applicable)'}
          {'\n'}{' \u2022 Description of the Event or Concern'}
        </Text>
      </View>
    </View>)
  }

  renderPart2Mobile = () => {
    return (
      <View style={{
        marginTop: 50,
        flexDirection: 'column',
        gap: 40,
        backgroundColor: White
      }}>
        <View style={{ flexDirection: "row", gap: 20 }}>
          <View style={{ width: 2, borderLeftWidth: 2, borderLeftColor: Styles.appColor1 }} />
          <View style={{ flexDirection: 'column', gap: 40 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 20 * scale }]}> Reporting Guidelines</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3, width: width - 50 }]}>
              When reporting an adverse event or safety concern,
              please provide the following information, if possible:
              {'\n \u2022 Product Name'}
              {'\n'}{' \u2022 Batch/Lot Number'}
              {'\n'}{' \u2022 Date of Event'}
              {'\n'}{' \u2022 Patient Information (if applicable)'}
              {'\n'}{' \u2022 Description of the Event or Concern'}
              {'\n'}
              {'\n'}
            </Text>
          </View>
        </View>

        <View style={{ flexDirection: "row", gap: 20 }}>
          <View style={{ width: 2, borderLeftWidth: 2, borderLeftColor: Styles.appColor1 }} />
          <View style={{ flexDirection: 'column', gap: 40 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 20 * scale }]}>Contact Information</Text>
            <Text style={[Styles.TextStyle2, { color: Styles.appColor3, width: width - 50 }]}>
              {' \u2022 Email: pv@jdsco.net'}
              {'\n'}{' \u2022 Phone1: +962 6 655 6125 Ext. 2'}
              {'\n'}{' \u2022 Phone2: +962 6 563 4488 Ext. 2 '}
              {'\n'}{' \u2022 Address: 48 Issam Al Ajlouni Street, Shmeisani,\n   Amman, Jordan'}
              {'\n'}
              {'\n'}
            </Text>
          </View>
        </View>

      </View>
    )
  }


  onBrandScroll = (e) => {
    const endReached =
      parseInt(e.nativeEvent.contentOffset.x) +
      parseInt(e.nativeEvent.layoutMeasurement.width) -
      parseInt(e.nativeEvent.contentSize.width) ==
      0;
    const startReached = e.nativeEvent.contentOffset.x == 0;
    if (endReached) {
      // brandFlag = -1;
      brandPos = 0;
      this.brandsView.scrollToOffset({ animated: false, offset: 0 });
    } else if (startReached) {
      brandFlag = 1;
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      width: width,
      alignItems: "center",
      backgroundColor: WHITE
    },
    image: {
      flex: 1,
      resizeMode: 'contain',
      justifyContent: 'center',
      width,
      height: 590,
    }
  });
}



export default Pharmacovigilance;
